import React from "react";
import JournalMenu from "../components/menu/general/JournalMenu";

const TabelPublikasi = () => {
  return <JournalMenu />;
};
export default TabelPublikasi;
